import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import authPlugin from '@/auth/plugin.js'

Vue.use(authPlugin)
Vue.use(Vuetify, {
  theme: {
    primary: '#2196f3',
    secondary: '#3f51b5',
    accent: '#00bcd4',
    error: '#f44336',
    warning: '#ffc107',
    info: '#607d8b',
    success: '#8bc34a'
  }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
